import Api from './ApiRequest';

export default {
    getAll: (params) => Api.get('/cent/vendors', params),
    getById: (id) => Api.get('/cent/vendor/' + id, null),
    save: (entity) => Api.post('/cent/vendor', entity),
    update: (id, entity) => Api.put('/cent/vendor/' + id, entity),
    delete: (id) => Api.delete('/cent/vendor/' + id),
};